<script lang="ts">
    import Cart_Table from "./Cart_Table.svelte";
    import { api, cart, toast, loader, config } from "../stores";
    import type { CartType } from "../model";
    import { getContext, onMount } from "svelte";
    import Cart_Form from "./Cart_Form.svelte";

    let cartList;
    $: cartList = $cart.list;

    let emptyShoppingList = true;
    let emptyClickCollect = true;

    const { open } = getContext("simple-modal");
    const { close } = getContext("simple-modal");
    let windowWidth = 0; // [pixel]
    const windowBreak = 1024; // [pixel]

    onMount(() => {
        const loaderId = $loader.show();
        $api.sendContentSquareEvent();
        cartList.subscribe(
            () => {
                emptyShoppingList = isTableEmpty("shoppingList");
                emptyClickCollect = isTableEmpty("clickCollect");
                $loader.hide(loaderId);
            },
            (e) => {
                $loader.hide(loaderId);
            }
        );
    });

    function isTableEmpty(type: CartType): boolean {
        let index = $cartList.findIndex((e) => e.cartType === type);
        return index < 0;
    }

    async function onPrintMemo() {
        const loaderId = $loader.show(
            "Votre liste de courses est en train d'être générée. Merci de patienter."
        );
        try {
            let resp = await $api.getCartShoppingListPdf(
                $cartList.filter((e) => e.cartType === "shoppingList")
            );
            let file = URL.createObjectURL(resp);
            window.open(file, "_blanc");
            $loader.hide(loaderId);
        } catch (err) {
            $toast.error(`Une erreur s'est produite : ${err}`, 10000);
            $loader.hide(loaderId);
        }
    }

    async function onShareMemo() {
        // responsive
        let styleWindowWrap = {
            margin: "auto",
            width: "100%",
            height: "auto",
            top: "auto",
        };
        let styleWindow = {
            margin: "auto",
            width: "40%",
            height: "auto",
            top: "auto",
        };
        if (windowWidth <= windowBreak) {
            styleWindowWrap = {
                margin: "0",
                width: "100%",
                height: "100%",
                top: "0",
            };
            styleWindow = {
                margin: "0",
                width: "100%",
                height: "100%",
                top: "0",
            };
        }
        // open the modal
        open(Cart_Form, { onOkay }, { styleWindowWrap, styleWindow });
    }

    /**
     * executed by the form modal on click "send"
     * @param emailExp: string - email of receiver
     * @param emailRec: string - email of
     * @param message: string
     */
    const onOkay = async (emailExp, emailRec, message) => {
        const loaderId = $loader.show();
        try {
            let resp = await $api.postCartShoppingList(
                $cartList.filter((e) => e.cartType === "shoppingList"),
                emailExp,
                emailRec,
                message
            );
            $loader.hide(loaderId);
            if (resp) {
                window.dataLayer.push({
                    event: "ProspectusEnvoiBonCommande",
                });
                $api.sendContentSquareEvent({
                    name: "ProspectusEnvoiBonCommande",
                    value: null,
                });
                $toast.success(
                    'Votre mémo courses à été envoyé à "' + emailRec + '".'
                );
            }
        } catch (err) {
            $toast.error(`Une erreur s'est produite : ${err}`, 10000);
            $loader.hide(loaderId);
        }
    };

    async function onSentClickCollect() {
        let cartCC = $cartList.filter((e) => e.cartType === "clickCollect");
        if (cartCC.length > 0) {
            const loaderId = $loader.show(
                "Votre panier est en cours de transfert. Vous allez être redirigez dans quelque secondes."
            );
            let resp = await $api.postCartClickCollect(cartCC);
            $loader.hide(loaderId);
            if (resp) {
                // $toast.success("Votre panier à été envoyé. Vous allez être redirigez ...", 10000) // todo : uncomment in prod
                $toast.error(
                    "Fonctionnalité en dev et non disponible pour l'instant."
                );
            }
        }
    }
</script>

<svelte:window bind:outerWidth={windowWidth} />

<!-- <h2 id="multi-cart-title">Votre sélection E.Leclerc</h2> -->

<!-- SHOPPING LIST ====================================================================================== -->
<div id="memo">
    <div class="header-cart">
        <span class="icon">
            <i class="fas fa-shopping-bag" />
        </span>

        <h1>Mon panier</h1>
    </div>
    <p>
        Préparez votre liste de course et imprimez-la pour faciliter votre
        visite en magasin
    </p>

    <div class="shopping-list-container">
        {#if !emptyShoppingList}
            <div class="shopping-list-table">
                <Cart_Table
                    type="shoppingList"
                    modelRow="simple"
                    color="dark-black"
                />
            </div>
        {/if}
    </div>
</div>

<!-- CLICK AND COLLECT ====================================================================================== -->
{#if !emptyClickCollect && $config.config.ClickAndCollect}
    <div id="clickCollect">
        <div class="shopping-list-header">
            <h2 class="txt-orange">Mes produits Click & Collect</h2>
            <h5>
                Envoyez le bon de réservation à votre magasin puis venez
                récupérer la commande
            </h5>
        </div>
        <div class="shopping-list-container">
            <div class="shopping-list-table">
                <Cart_Table
                    type="clickCollect"
                    modelRow="standard"
                    color="orange"
                />
            </div>

            <div class="shopping-list-action">
                <div class="footer-action">
                    <button class="bg-orange" on:click={onSentClickCollect}>
                        Envoyer mon bon de réservation Click & Collect
                        <span class="icon">
                            <i class="envelope" />
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}

<!-- ====================================================================================== -->
<style lang="scss">
    @import "../styles/variables";

    .header-cart {
        margin: 1rem;
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
        color: black;
        h1,
        span {
            font-size: 20px;
        }
    }

    h2 {
        font-size: 26px;
        line-height: 30px;
        font-weight: bold;
    }
    h5 {
        font-size: 15px;
        line-height: 18px;
        font-weight: bold;
    }

    #memo {
        background-color: #ffffff;
        font-weight: bold;
        max-height: 100%;
        overflow: auto;
        border-radius: 25px;
        padding: 1rem;
        @media (max-width: $mobile-breakpoint) {
            // margin-top: 5rem;
        }
    }

    #clickCollect {
        font-weight: bold;
    }

    .shopping-list-header {
        padding: 0.5em;
    }

    // global ============================

    //   #multi-cart-title{
    //     text-align: center;
    //     margin-top: 10px;
    //     margin-bottom: 15px;
    //     color: #000000;
    //   }
    //.cart-empty{
    //  margin: 15px;
    //  color: $grey-darken;
    //}
</style>
